import { combineReducers } from 'redux';
import list from './list';
import paging from './paging';
import sorting from './sorting';
import filters from './filters';
import count from './count';
import categories from './categories';
import activeCategory from './activeCategory';
import detail from './detail';
import countGroups from './countGroups';

export default combineReducers({
  list,
  paging,
  sorting,
  filters,
  count,
  countGroups,
  categories,
  activeCategory,
  detail,
});
